export const LEADERS_LEADERBOARD_PAGINATION_STEP = 50;
export const LEADERS_DASHBOARD_PAGINATION_STEP = 15;
